import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-span-6" }

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    role: {
        type: Object,
        default: () => ({})
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormSection, null, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode(" Role Information ", -1)
    ]))]),
    description: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createTextVNode(" Relevant data and other details ", -1)
    ]))]),
    form: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TextInput, {
          "model-value": props.role.name,
          id: "role_name",
          name: "role_name",
          label: "Role Name",
          placeholder: "Role Name",
          disabled: ""
        }, null, 8, ["model-value"])
      ])
    ]),
    _: 1
  }))
}
}

})